export const ProjectData=[
    {
        id:1,
        title:"Resume Manager",
        about: "ResumeManager, simplifies recruitment by automating CV management. Candidates apply online through a single form, reducing time and effort. Recruiters benefit from streamlined processes, enhanced evaluation, and collaborative hiring. Optimize your selection process with ResumeManager.",
        tags:["Java", "Javascript", "Html", "Css"],
        //demo:"https://github.com/ThantZinPhyo-OP/Portfolio-Website",
        github:"https://github.com/KERROUFIRDAOUS/ResumeManager",
        image:"https://github.com/KERROUFIRDAOUS/ResumeManager/assets/52587545/84a57ab8-fe77-4dc0-844a-a6542d7a3143",
    },
    {
        id:2,
        title:"DreamiNorth",
        about: "DreamiNorth is a web application for hotel management and reservations. It also features a lodging section where users can add apartments for rent and receive feedback from potential customers interested in their listings.",
        tags:["Php", "Laravel",  "Javascript" ,"Html", "Css"],
        //demo:"https://github.com/ThantZinPhyo-OP/Portfolio-Website",
        github:"https://github.com/KERROUFIRDAOUS/E-tourisme",
        image:"https://github.com/KERROUFIRDAOUS/E-tourisme/assets/52587545/766893f0-496a-45d7-9256-04c78639d368",
    },
];